/**
 * @param timestampFilter - a {@link TableStringFilterInput} that is used with a date range
 * @returns an object with `start` and `end` keys. Each one is either the value of the filter,
 * which is expected to be an ISO date string, or null, if it does not exist.
 */
export const timestampFilterToISODateRange = (
    timestampFilter: Maybe<TableStringFilterInput | TableIntFilterInput>,
): ISODateRange | null => {
    const lt = timestampFilter?.lt ?? null;
    const gt = timestampFilter?.gt ?? null;
    const between = timestampFilter?.between ?? null;

    if (
        typeof lt === 'number' ||
        typeof gt === 'number' ||
        typeof between?.[0] === 'number' ||
        typeof between?.[1] === 'number'
    ) {
        return null;
    }

    let end: Maybe<string> = lt;
    let start: Maybe<string> = gt;

    if (between !== null) {
        start = between?.[0] ?? null;
        end = between?.[1] ?? null;
    }

    return {
        start,
        end,
    };
};
